/* Keepsake Lines: mobile thumbnails under the main product gallery (Shopify media, pre-personalization).
   Hidden automatically once the Teeinblue gallery mounts (CSS) and on desktop widths. */
(function () {
  'use strict';
  if (location.pathname.indexOf('/products/') === -1) return;
  function slidesOf(g) {
    return Array.prototype.filter.call(g.querySelectorAll('slideshow-slide'), function (s) { return s.querySelector('img'); });
  }
  function setActive(strip, i) {
    var ts = strip.querySelectorAll('.kl-mt__t');
    for (var k = 0; k < ts.length; k++) ts[k].classList.toggle('is-on', k === i);
  }
  function nearestIndex(g, slides) {
    var box = slides[0] && slides[0].parentElement ? slides[0].parentElement.getBoundingClientRect() : g.getBoundingClientRect();
    var best = 0, bd = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var r = slides[i].getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - (box.left + box.width / 2));
      if (d < bd) { bd = d; best = i; }
    }
    return best;
  }
  function build() {
    var g = document.querySelector('media-gallery');
    if (!g || g.closest('product-card, .product-card, dialog')) return;
    if (g.querySelector('.kl-mt')) return;
    var slides = slidesOf(g);
    if (slides.length < 2) return;
    var strip = document.createElement('div');
    strip.className = 'kl-mt';
    slides.forEach(function (s, i) {
      var im = s.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kl-mt__t' + (i === 0 ? ' is-on' : '');
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      var t = document.createElement('img');
      t.alt = '';
      t.loading = 'lazy';
      t.decoding = 'async';
      var src = im.currentSrc || im.src || '';
      if (src) {
        if (src.indexOf('width=') > -1) src = src.replace(/width=[0-9]+/, 'width=160');
        else src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      }
      t.src = src;
      b.appendChild(t);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        try { s.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (err) { s.scrollIntoView(); }
        setActive(strip, i);
      });
      strip.appendChild(b);
    });
    g.appendChild(strip);
    var track = slides[0].parentElement;
    if (track) {
      var st = null;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { setActive(strip, nearestIndex(g, slides)); }, 120);
      }, { passive: true });
    }
  }
  var t = null;
  function scan() { clearTimeout(t); t = setTimeout(build, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  try { new MutationObserver(scan).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();